import { render, staticRenderFns } from "./InternalManagementSection.vue?vue&type=template&id=1281f216"
import script from "./InternalManagementSection.vue?vue&type=script&lang=js"
export * from "./InternalManagementSection.vue?vue&type=script&lang=js"
import style0 from "./InternalManagementSection.vue?vue&type=style&index=0&id=1281f216&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports